
export default {
    provide: {
        mysignGlobals: { webroot: window.webroot,
            languagepath: window.languagepath, language: window.language,
            user: window.user
        },
        versandAufteilungPreis: window.FlyerlineConfig.versandaufteilungPreis
    }
}
